<div class="container-fluid d-flex flex-column h-100 w-100">
  <div class="row d-flex justify-content-between mr-2 mb-3">
    <fieldset>
      <div class="d-flex align-items-center px-2">
        <div class="mr-2">
          <button
            (click)="loadItems()"
            [ngClass]="{ 'btn-success': isLoading, 'btn-light': !isLoading }"
            class="btn btn-sm"
          >
            <i [ngClass]="{ 'la-spin': isLoading }" class="la la-refresh"></i>
          </button>
        </div>
        <div class="mr-2">
          <button
            alt="clear filter"
            (click)="grid?.clearAllFilters()"
            [disabled]="!grid?.isFilterApplied"
            [ngClass]="{
              'clear-filter position-relative': grid?.isFilterApplied
            }"
            class="btn btn-light btn-sm"
          >
            <i class="las la-filter"></i>
          </button>
        </div>
        <div class="mr-2">
          <button
            (click)="generatePlanPdf()"
            [disabled]="
              isLoading ||
              selectedNodes.length === 0 ||
              auth.isViewer('routing')
            "
            class="btn btn-sm btn-primary"
          >
            <i class="la la-fw la-file-pdf"></i>
            {{ "navigations.plan.generate_document" | translate }}
          </button>
        </div>
        <div class="mr-2">
          <button
            (click)="generatePlanCsv()"
            [disabled]="
              isLoading ||
              selectedNodes.length === 0 ||
              auth.isViewer('routing')
            "
            class="btn btn-sm btn-primary"
          >
            <i class="la la-fw la-file-csv"></i>
            {{ "navigations.task.export" | translate }}
          </button>
        </div>
        <div
          [isDisabled]="selectedNodes.length === 0"
          class="btn-group mr-1"
          dropdown
        >
          <button
            class="dropdown-toggle btn btn-sm btn-primary"
            dropdownToggle
            type="button"
          >
            <ng-container *ngIf="selectedNodes.length > 0"
              >{{ "navigations.with" | translate }}
              <strong>{{ selectedNodes.length }}</strong>
              {{ "navigations.selected" | translate }}
            </ng-container>
            <ng-container *ngIf="selectedNodes.length === 0">{{
              "navigations.no_selection" | translate
            }}</ng-container>
            <span class="caret"></span>
          </button>
          <ul *dropdownMenu class="dropdown-menu">
            <li
              (click)="!showReleasedVersionOnly && showMassEditModal()"
              class="btn btn-sm dropdown-item"
              *ngIf="!auth.isViewer('routing')"
              [class.disabled]="showReleasedVersionOnly"
              [attr.aria-disabled]="showReleasedVersionOnly"
            >
              <i class="la la-fw la-pencil-alt"></i>
              {{ "navigations.edit" | translate }}
            </li>
            <li (click)="grid?.export('xlsx')" class="btn btn-sm dropdown-item">
              <i class="la la-fw la-file-excel"></i> XLSX
            </li>
            <li (click)="grid?.export('csv')" class="btn btn-sm dropdown-item">
              <i class="la la-fw la-file-csv"></i> CSV
            </li>
            <li
              class="divider dropdown-divider"
              *ngIf="!auth.isViewer('routing')"
            ></li>
            <li role="menuitem" *ngIf="!auth.isViewer('routing')">
              <a
                class="dropdown-item btn btn-sm btn-danger"
                (click)="!showReleasedVersionOnly && showMassDeleteConfirm()"
                [class.disabled]="showReleasedVersionOnly"
                [attr.aria-disabled]="showReleasedVersionOnly"
              >
                <i class="la la-fw la-trash"></i>
                {{ "navigations.delete" | translate }}
              </a>
            </li>
          </ul>
        </div>
        <div class="mr-2">
          <button
            (click)="showWorkloadChartModal()"
            [disabled]="showReleasedVersionOnly"
            class="btn btn-sm btn-primary"
          >
            <i class="la la-fw la-chart-line"></i>
            {{ "navigations.plan.show_normalized_workload_chart" | translate }}
          </button>
        </div>
        <div class="mr-2">
          <button
            (click)="releasePlans()"
            [disabled]="
              isLoading ||
              selectedNodes.length === 0 ||
              auth.isViewer('routing') ||
              showReleasedVersionOnly
            "
            class="btn btn-sm btn-primary"
          >
            <i class="la la-fw la-rocket"></i>
            {{ "navigations.plan.release" | translate }}
          </button>
        </div>
        <div
          class="released-only-switch ml-2 pl-2 d-flex align-items-center border-left"
        >
          <label
            class="released-only-label mb-0 mr-2 text-nowrap"
            for="showReleasedVersionOnly"
            >{{
            "navigations.plan.show_released_version_only" | translate
          }}</label>
          <div class="custom-control custom-switch">
            <input
              id="showReleasedVersionOnly"
              type="checkbox"
              class="custom-control-input"
              [(ngModel)]="showReleasedVersionOnly"
              (ngModelChange)="onReleasedVersionOnlyChange()"
            />
            <label
              class="custom-control-label"
              for="showReleasedVersionOnly"
            ></label>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="row h-100">
    <div class="flex-column h-100 col-12">
      <app-grid
        [gridUid]="'routing_plans'"
        (rowDoubleClicked)="
          auth.isViewer('routing') || showReleasedVersionOnly
            ? null
            : onRowClicked($event)
        "
        (selectionChanged)="onSelectionChanged($event)"
        [gridOptions]="gridOptions"
        [rowData]="items"
        class="ag-theme-alpine"
      >
      </app-grid>
    </div>
  </div>
</div>
